import UpdateResourcePropertyPlugin from './UpdateResourcePropertyPlugin'

const kvSyncPlugins = [
  UpdateResourcePropertyPlugin,
]

export default kvSyncPlugins
